// extracted by mini-css-extract-plugin
export var svg = "MenuText-module--svg--DzKac";
export var wrap = "MenuText-module--wrap--D0VoH";